/** Refund and store credit both pay out the value of the items, so both need it to be refundable still. */
export const paysOut = (option) => option.kind === 'refund' || option.kind === 'store_credit';
/** Which resolutions the claimed reasons allow. A reason with no list allows all of them. */
export function allowedResolutions(config, reasonIds) {
    const lists = reasonIds
        .map((id) => config.reasons.find((reason) => reason.id === id))
        .filter((reason) => reason !== undefined)
        .map((reason) => reason.allowResolutions)
        .filter((list) => list.length > 0);
    if (lists.length === 0)
        return config.resolutions;
    // A mixed-reason claim may only offer what every one of its reasons allows.
    return config.resolutions.filter((resolution) => lists.every((list) => list.includes(resolution.id)));
}
/** A note is required when the intake asks for one, or any claimed reason does. */
export function isNoteRequired(config, reasonIds) {
    if (config.intake.note === 'required')
        return true;
    return reasonIds.some((id) => config.reasons.find((reason) => reason.id === id)?.requireNote === true);
}
/** Same for photos: one item needing a photo makes the upload required for the claim. */
export function isPhotoRequired(config, reasonIds) {
    if (config.intake.photos.mode === 'off')
        return false;
    if (config.intake.photos.mode === 'required')
        return true;
    return reasonIds.some((id) => config.reasons.find((reason) => reason.id === id)?.requirePhoto === true);
}
/** The notices to show for a mixed-reason claim, de-duplicated by text. */
export function noticesFor(config, reasonIds) {
    const seen = new Set();
    const notices = [];
    for (const id of reasonIds) {
        const notice = config.reasons.find((reason) => reason.id === id)?.notice;
        if (notice && !seen.has(notice.text)) {
            seen.add(notice.text);
            notices.push(notice);
        }
    }
    return notices;
}
//# sourceMappingURL=selectors.js.map